export default defineNuxtPlugin({
  name: 'insider',
  parallel: false,
  setup() {
    const router = useRouter()
    let firstLoad = true

    const runInsider = async () => {
      const config = useRuntimeConfig();
      const baseUrl = config.public.BASE_URL;
      const route = useRoute();
      const userStore = useUserStore();
      const orderId = route.path.match(/order-received\/(\d+)/)?.[1] || null

      window.dataLayer = window.dataLayer || [];
      if (!userStore.user?.id) return;
      const userInsiderInfoSdk = userStore?.dataInsiderSdk || null;
      const detect_country = useCookie('detect_country');

      console.log('--- detect_country: ',detect_country.value)

      if (userInsiderInfoSdk && Object.keys(userInsiderInfoSdk).length > 0 )  {
      console.log('1111111111',userInsiderInfoSdk)
      if (userInsiderInfoSdk.uuid != '' || (userInsiderInfoSdk.uuid == '' && userStore.user.role != 'customer' && userStore.user.role != 'subscriber')) {
        if (userInsiderInfoSdk.phone_number?.trim() === '+' || !userInsiderInfoSdk.phone_number) {
           userInsiderInfoSdk.phone_number = '';
        }

        const lang = detect_country.value ==='ms-my' ? 'ms_MY' : 'en_MY';
        userInsiderInfoSdk.language = lang;
        window.dataLayer.unshift({
            event: "insider_sdk_user",
            type: "user",
            insider_user_value: userInsiderInfoSdk
          });
          return;
      }
       
      }

      try {
        const userData: any = await $fetch(`${baseUrl}api/wp-json/skj/v1/insider/user`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            "Authorization": `Bearer ${userStore.csrf}`,
            'X-API-Server': userStore.csrf_server
          },
          body: JSON.stringify({
            user_id: userStore.user.id || null,
            orderId,
            timestamp: Date.now()
          })
        });

        const insiderSdk = userData['insider_sdk'] || null;
console.log('22222222',insiderSdk)
        if (insiderSdk) {
          window.dataLayer.unshift({
            event: "insider_sdk_user",
            type: "user",
            insider_user_value: insiderSdk
          });
        }
      } catch (error) {
        console.error('Insider error:', error);
      }
    }
    runInsider()
    router.afterEach(() => {
      if (firstLoad) {
        firstLoad = false
        return
      }
      runInsider()
    })
  }
})
